module.exports = __webpack_public_path__ + "img/hover_bg.8f3da6a0.png";